import { render, staticRenderFns } from "./life-insurance-modal.vue?vue&type=template&id=1e309122&scoped=true"
import script from "./life-insurance-modal.vue?vue&type=script&lang=ts"
export * from "./life-insurance-modal.vue?vue&type=script&lang=ts"
import style0 from "./life-insurance-modal.vue?vue&type=style&index=0&id=1e309122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e309122",
  null
  
)

export default component.exports